import React, { useState, useEffect } from 'react';
import { api, apiUrl } from '../utils/api';
import { Spinner } from '../components/UI';

export default function Configuracion() {
  const [historial, setHistorial] = useState([]);
  const [cargando, setCargando] = useState(true);

  const [usuarioReset, setUsuarioReset] = useState('antonio');
  const [claveMaestra, setClaveMaestra] = useState('');
  const [nuevaPassword, setNuevaPassword] = useState('');
  const [mensajeReset, setMensajeReset] = useState(null);
  const [enviandoReset, setEnviandoReset] = useState(false);

  const cargar = () => {
    api('/backup/historial').then(res => { setHistorial(res); setCargando(false); });
  };

  useEffect(() => { cargar(); }, []);

  async function resetearPassword(e) {
    e.preventDefault();
    setMensajeReset(null);
    setEnviandoReset(true);
    try {
      const res = await fetch(apiUrl('/auth/reset-password'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          usuario: usuarioReset,
          nueva_password: nuevaPassword,
          clave_maestra: claveMaestra,
        }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || 'No se pudo cambiar la contraseña');
      }
      setMensajeReset({ tipo: 'ok', texto: `Contraseña de ${usuarioReset} actualizada.` });
      setClaveMaestra('');
      setNuevaPassword('');
    } catch (e) {
      setMensajeReset({ tipo: 'error', texto: e.message });
    } finally {
      setEnviandoReset(false);
    }
  }

  return (
    <div className="page-content">
      <h1 className="page-title">Configuración</h1>

      <div className="card" style={{ marginBottom: '1rem' }}>
        <p style={{ fontWeight: 600, marginBottom: '.6rem', color: 'var(--azul)' }}>Backup de la base de datos</p>
        <p style={{ fontSize: '.875rem', color: 'var(--gris-5)', marginBottom: '.75rem' }}>
          Todos los días a las 3:00 AM (hora de Uruguay) el sistema genera automáticamente una copia
          de seguridad y la envía por email y/o la sube a Google Drive (si están configurados).
          También podés generar una copia manual ahora mismo.
        </p>
        <a href={apiUrl('/backup/descargar')} className="btn btn-primary" download>
          📥 Descargar backup ahora
        </a>
      </div>

      <div className="card" style={{ marginBottom: '1rem' }}>
        <p style={{ fontWeight: 600, marginBottom: '.6rem', color: 'var(--azul)' }}>Cambiar contraseña de usuario</p>
        <p style={{ fontSize: '.875rem', color: 'var(--gris-5)', marginBottom: '.75rem' }}>
          Necesitás la clave maestra para confirmar el cambio.
        </p>
        <form onSubmit={resetearPassword} style={{ display: 'flex', flexDirection: 'column', gap: '.6rem', maxWidth: '320px' }}>
          <select value={usuarioReset} onChange={(e) => setUsuarioReset(e.target.value)} className="input">
            <option value="antonio">antonio</option>
            <option value="viviana">viviana</option>
          </select>
          <input
            type="password"
            placeholder="Nueva contraseña"
            value={nuevaPassword}
            onChange={(e) => setNuevaPassword(e.target.value)}
            className="input"
            required
          />
          <input
            type="password"
            placeholder="Clave maestra"
            value={claveMaestra}
            onChange={(e) => setClaveMaestra(e.target.value)}
            className="input"
            required
          />
          {mensajeReset && (
            <p style={{ fontSize: '.85rem', color: mensajeReset.tipo === 'ok' ? 'var(--verde)' : '#c0392b' }}>
              {mensajeReset.texto}
            </p>
          )}
          <button type="submit" className="btn btn-primary" disabled={enviandoReset}>
            {enviandoReset ? 'Cambiando...' : 'Cambiar contraseña'}
          </button>
        </form>
      </div>

      <div className="card">
        <p style={{ fontWeight: 600, marginBottom: '.6rem', color: 'var(--azul)' }}>Historial de backups</p>
        {cargando ? <Spinner texto="Cargando..." /> : (
          historial.length === 0 ? (
            <p style={{ color: 'var(--gris-4)', fontSize: '.875rem' }}>Todavía no se generó ningún backup.</p>
          ) : (
            <div className="tabla-wrap">
              <table className="tabla">
                <thead><tr><th>Fecha</th><th>Tipo</th><th>Destino</th><th>Resultado</th></tr></thead>
                <tbody>
                  {historial.map((h, i) => (
                    <tr key={i}>
                      <td>{h.fecha}</td>
                      <td>{h.tipo === 'manual' ? 'Manual' : 'Automático'}</td>
                      <td>{h.destino}</td>
                      <td>
                        {h.ok ? '✅ OK' : (
                          <>
                            ⚠️ Falló
                            {h.detalle && (
                              <div style={{ fontSize: '.75rem', color: 'var(--gris-4)', marginTop: '.2rem' }}>
                                {h.detalle}
                              </div>
                            )}
                          </>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )
        )}
      </div>
    </div>
  );
}
